import axios from 'axios'
import analytics from '../config/analytics';

export const STATUS_CODE_FAIL_BAD_REQUEST = 400;
export const STATUS_CODE_FAIL_FORBIDDEN = 403;
export const STATUS_CODE_FAIL_UNAUTHORIZED = 401;
// export const REACT_APP_DISDK_PS_API_ENDPOINT='https://image.adobe.io'
// export const REACT_APP_DISDK_RECAPTCHA_SITE_KEY='6Lch52caAAAAAMm2P5EFnvVbOzzX9oVXtUC0r1A-'
// 6Lch52caAAAAAC6jqleboug1WVdq6UtyqDOOT9po
// export const REACT_APP_DISDK_PS_API_ENDPOINT='https://image-stage.adobe.io'
// export const REACT_APP_DISDK_RECAPTCHA_SITE_KEY='6LecjOQZAAAAAO2g37NFPwnIPA6URMXdAzBFZTpZ'
// export const process.env.REACT_APP_DISDK_KEY='cis_skycity' //TODO
// export const REACT_APP_DISDK_RECAPTCHA_SCRIPT_URL='https://www.google.com/recaptcha/api.js'

export async function getAperitifToken() {
    try {
        const token = await window.grecaptcha.execute()
        const response = await fetch(
            `${process.env.REACT_APP_DISDK_PS_API_ENDPOINT}/utils/aperitif/token`,
            {
                headers: {
                    'x-api-key': process.env.REACT_APP_DISDK_KEY,
                    'x-recaptcha-token': token
                },
            }
        )
        logMsg(null, response, 'getAperitifToken')
        if (response.status >= STATUS_CODE_FAIL_BAD_REQUEST) {
            return {
                response: response,
                error: true
            }
        } else {
            return {
                response: response,
                error: false
            }
        }
    } catch(e) {
        return {
            response: null,
            error: true,
            e: e
        }
    }
}

export async function getAperitifStorage(num, getAperitifStorage) {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_DISDK_PS_API_ENDPOINT}/utils/aperitif/storage?num=${num}`,
            {
                headers: {
                    'x-api-key': process.env.REACT_APP_DISDK_KEY,
                    'Authorization': `Bearer ${getAperitifStorage.userToken}`
                },
            }
        )
        logMsg(null, response, 'getAperitifStorage')
        if (response.status >= STATUS_CODE_FAIL_BAD_REQUEST) {
            return {
                response: response,
                error: true
            }
        } else {
            return {
                response: response,
                error: false
            }
        }
    } catch(e) {
        return {
            response: null,
            error: true,
            e: e
        }
    }
}

export async function getUtStorage(num, ut) {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_DISDK_PS_API_ENDPOINT}/utils/storage?num=${num}`,
            {
                headers: {
                    'x-api-key': process.env.REACT_APP_DISDK_KEY,
                    'Authorization': `Bearer ${ut}`
                },
            }
        )
        logMsg(null, response, 'getUtStorage')
        return {
            response: response,
            error: false
        }
    } catch(e) {
        return {
            response: null,
            error: true,
            e: e
        }
    }
}

export async function getPutUrl(tempOutputs, assetNum) {
    try {
        // const uuid = uuidv4()
        return {
            url: tempOutputs.urls[assetNum],
            error: false,
            msg: null
        }
    } catch(e) {
        return {
            url: null,
            error: true,
            msg: e.message
        }
    }
}

export async function uploadAssetFile(file, opts={}, cb) {
    try {
        analytics.sendEventName('function', `lib:uploadfile`)
        axios.put(file, opts.data, opts.config)
            .then((response) => {
                logMsg(null, response.status, 'Asset upload')
                cb(response)
            })
            .catch((error) => {
                logMsg(null, error, 'Asset upload error')
                cb(false, 'The image or action URL may be expired')
            })
            .then(() => {
                // console.log('uploadAsset done');
            })
    } catch(e) {
        cb(null, e)
    }
}

export function getFilenameWithoutExt (longName) {
    var fileName = longName.substring(longName.lastIndexOf('/') + 1)
    return fileName.split('.').slice(0, -1).join('.')
}

export function createRecaptchaElement() {
    const script = document.createElement('script')
    script.setAttribute('src', process.env.REACT_APP_DISDK_RECAPTCHA_SCRIPT_URL)
    const challenge = document.createElement('div')
    challenge.className = 'g-recaptcha'
    challenge.dataset.size = 'invisible'
    challenge.dataset.sitekey = process.env.REACT_APP_DISDK_RECAPTCHA_SITE_KEY
    document.body.appendChild(script)
    document.body.appendChild(challenge)
}

export function logAlert (e, msg) {
    const str = (e && e.message) || msg || 'Something went wrong'
    // error(`${__('msg_error_space')}${str}`, {
    //     timeout: TIMEOUT_TOAST_FAIL
    // })
    alert(str)
}

export const getDebugMode = () => {
    const curUrl = new URL(window.location.href)
    const curMode = curUrl.searchParams.get('d')
    switch (curMode) {
    case "1":
        return true
    default:
        return false
    }
}

export function logMsg(e, msg, title) {
    const dMode = getDebugMode()
    if (dMode) {
        console.log('*************************************')
        if (msg) {
            switch (typeof msg) {
                case 'object':
                    console.log(`${title || ''}: ${JSON.stringify(msg,null,2)}`)
                    break;
                case 'array':
                    console.table(msg)
                    break;
                default:
                    console.log(`${title || ''}: ${msg}`)
                    break;
            }
        }
        if (e) {
            console.log(`LOG: ${e.message} - ${e.stack}`)
        }
    }
}

export async function runAperitifOperation(token, bodyObject) {
    try {
        // const cisEndpoint = `${process.env.REACT_APP_DISDK_PS_API_ENDPOINT}/utils/aperitif/operation/sensei/mask`
        const cisEndpoint = `${process.env.REACT_APP_DISDK_PS_API_ENDPOINT}/utils/aperitif/operation/sensei/cutout`
        const requestOptions = {
            method: 'POST',
            headers: {
                'X-API-KEY': process.env.REACT_APP_DISDK_KEY,
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(bodyObject)
        }
        const response = await fetch(cisEndpoint, requestOptions)
        logMsg(null, response, 'runAperitifOperation')

        const parsed = await response.json();
        logMsg(null, parsed, 'runAperitifOperation')
        if (parsed._links && parsed._links.self && parsed._links.self.href) {
            return getResults(parsed._links.self.href, token);
        }
        return {
            response: response,
            error: true
        }
    } catch(e) {
        return {
            response: null,
            error: true,
            e: e
        }
    }
}

export async function getResults(pollHref, token) {
    const response = await fetch(pollHref, {
        method: 'GET',
        headers: {
            'x-api-key': process.env.REACT_APP_DISDK_KEY,
            Authorization: `Bearer ${token}`
        }
    });
    const POLL_MS = 1000;
    if (response.status === 200) {
        const job = await response.json()
        const status = (job.outputs && job.outputs[0].status) || job.status
        logMsg(null, status, 'getResults status')
        switch (status) {
            case 'succeeded':
                return {
                    response: response,
                    job: job,
                    error: false
                }
            case 'running':
            case 'pending':
                await wait(POLL_MS);
                return getResults(pollHref, token);
            case 'failed':
                // throw new Error(`Job failed, job id was ${job.jobID}`);
                return {
                    response: response,
                    error: true,
                    job: job,
                    e: new Error(`Job failed, job id was ${job.jobID}`)
                }
            default:
                // throw new Error(
                //     `Unexpected job status of ${status}, job id was ${job.jobID}`
                // );
                return {
                    response: response,
                    error: true,
                    job: job,
                    e: new Error(
                        `Unexpected job status of ${status}, job id was ${job.jobID}`
                    )
                }
        }
    } else {
        throw new Error(`Expected 200 when polling ${pollHref}`);
    }
}

function wait(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
